/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const KillswitchScheduleStartNow = {
  Now: "now",
} as const;
export type KillswitchScheduleStartNow = ClosedEnum<
  typeof KillswitchScheduleStartNow
>;

/** @internal */
export const KillswitchScheduleStartNow$inboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleStartNow
> = z.enum(KillswitchScheduleStartNow);
/** @internal */
export const KillswitchScheduleStartNow$outboundSchema: z.ZodMiniEnum<
  typeof KillswitchScheduleStartNow
> = KillswitchScheduleStartNow$inboundSchema;
